<template>
    <div id="invoice_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="invoiceHeader" v-if="$route.params.id > 0">Update Customer Invoice</span>
                    <span class="page-title" id="invoiceHeader" v-else>Add Customer Invoice</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackInvoiceList"  >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content invoice-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="InvoiceForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div v-if="$route.params.id > 0" class="col form-group mt-3">
                                        <label class="control-label" for="invoice_number">Invoice #: </label>
                                        <span class="label font-semibold">{{invoice_number}}</span>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="customer_id">Customer:</label>
                                        <v-select v-model="customer_id" name="customer_id" id="customer_id" label="text" @input="onChangeCustomer(customer_id)" :filterable="false" :options="customerArr" @search="onSearchCustomer" placeholder="Select Customer" class='custom-ci-auto-search close-remove' v-on:change="termSelect()" :disabled="disableAll">
                                            <template slot="no-options">
                                                Search Customer...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ customer_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Customer Email:</label>
                                        <input type="text" class="form-control" v-model="emails" id="emails" placeholder="Enter Emails" name="emails">
                                        <div class="field-error">{{emails_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="invoice_type">Term:</label>
                                        <v-select v-model="term" name="term" placeholder="Select Term" label="text" class='close-remove' :options="termsArr" :disabled="disableAll" @input="onTermChange($event)">
                                        </v-select>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require">Invoice Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="invoice_date" name="invoice_date" v-model="invoice_date" :config="optionsDate" aria-describedby="basic-addon3" :disabled="disableAll" @dp-change="onInvDateChange"></date-picker>
                                            <label for="invoice_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{invoice_date_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require">Due Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="due_date" name="due_date" v-model="due_date" :config="optionsDueDate" aria-describedby="basic-addon3" :disabled="disableAll"></date-picker>
                                            <label for="due_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{due_date_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="invoice_type">Invoice Type:</label>
<!--                                      When editing the invoice type is not allowed to be changed.-->
                                        <v-select v-if="isEdit" v-model="invoice_type" name="invoice_type" placeholder="Select Invoice Type" label="text" class='close-remove' :options="invoiceTypesArr" :disabled="disableInvType">
                                        </v-select>
<!--                                      When creating the invoice type is allowed to be selected from the dropdown and when the invoice type is changed, the invoiceTypeChange event is called.-->
                                        <v-select v-else v-model="invoice_type" name="invoice_type" placeholder="Select Invoice Type" label="text" class='close-remove' :options="invoiceTypesArr" :disabled="disableAll" @change="invoiceTypeChange($event)">
                                        </v-select>
                                        <div class="field-error">{{invoice_type_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="customer_purchase_order">PO:</label>
                                        <v-select v-model="customer_purchase_order" name="customer_purchase_order" id="customer_purchase_order" label="text" :filterable="false" :options="customerPurchaseOrderArr" @search="onSearchPO" placeholder="Select PO" class='custom-ci-auto-search close-remove' :disabled="disableAll">
                                            <template slot="no-options">
                                                Search PO...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="state">Location:</label>
                                        <v-select v-model="location_id" name="location_id" placeholder="Select Location." label="text" :options="locationArr" :disabled="disableAll" @change="locationChange($event)">
                                        </v-select>
                                        <div class="field-error">{{location_error_msg}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label" for="state">Reason:</label>
                                        <v-select v-model="reason_id" name="reason_id" placeholder="Select reason." label="text" :options="reasonArr" :disabled="disableAll">
                                        </v-select>
                                        <!-- <div class="field-error">{{reason_error_msg}}</div> -->
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label" for="period">Notes:</label>
                                        <textarea class="form-control" v-model="note" id="attention" placeholder="Enter Notes" name="note" rows="4">
                                        </textarea>
                                        <label for="show_notes" class="checkbox-custom">
                                        <input type="checkbox" v-model="show_notes" id="show_notes" name="show_notes">
                                        Show Notes in Invoice
                                        </label>
                                    </div>
                                </div>
                                <div class="table-responsive-sm mt-4">
<!--                                  if the invoice type of part sale has been selected then the following table is displayed-->
                                  <table v-if="partSaleInvoiceItem" class="table table-bordered table-sm" style="table-layout: fixed;">
                                    <thead>
                                    <tr class="table-primary">
                                      <th scope="col" class="require" style="width: 30%;">Part Name</th>
                                      <th scope="col">Description</th>
                                      <th scope="col" class="require text-right">Quantity</th>
                                      <th scope="col" class="require text-right">Rate</th>
                                      <th scope="col" class="text-right">Total</th>
                                      <th scope="col"> Action </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(row, index) in rows" :key="index">

                                      <td>
                                        <v-select v-model="row.part" :id="'part_'+ index" :name="'part_'+ index" label="text" :filterable="false" :options="componentArr" @search="onSearchComponent" placeholder="Select Part" class='custom-ci-auto-search contract-data' :disabled="disableAll" @change="partChange($event,row,index)">
                                          <template slot="no-options">
                                            Search Parts...
                                          </template>
                                          <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                              {{ option.text }}
                                            </div>
                                          </template>
                                          <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                              {{ option.text }}
                                            </div>
                                          </template>
                                        </v-select>
                                        <div class="field-error">{{row.part_name_error_msg}}</div>
                                      </td>
                                      <td>
                                        <input type="text" placeholder="Description" v-model="row.description" v-on:change="changeInput($event,index)"
                                               :id="'description'+ index" :name="'description'+ index" class="vgt-input text-right" :disabled="disableAll" >
                                      </td>
                                      <td>
                                        <input type="text" placeholder="Quantity"
                                               v-model="row.quantity"  :id="'quantity_'+ index" :name="'quantity_'+ index"  v-on:keyup="calculateAmount($event,index)" style="width:99% !important" class="vgt-input text-right"
                                               @keypress="isNumberCheck($event,index, 'qty')" :disabled="disableAll">
                                        <div class="field-error">{{row.quantity_error_msg}}</div>
                                      </td>
                                      <td>
                                        <input type="text" placeholder="Unit Price" v-model="row.unit_price" v-on:change="changeInput($event,index)"
                                               @input="validateInput($event,index)" v-on:keyup="calculateAmount($event,index)"
                                               @keypress="isNumberCheck($event,index, 'price')" :id="'unit_price_'+ index" :name="'unit_price_'+ index" style="width:99% !important" class="vgt-input text-right" :disabled="disableAll" >
                                        <div class="field-error">{{row.unit_price_error_msg}}</div>
                                      </td>
                                      <td>
                                        <input type="text" disabled placeholder="Total"  v-model="row.total" id="total" name="total" style="width:99% !important" class="vgt-input text-right">
                                      </td>
                                      <td class="text-center valign-middle">
                                        <template v-if="rows.length != 1">
                                          <a href="javascript:void(0);" v-on:click="removeItem(index);"> <i class="fp-remove"></i> </a>
                                        </template>
                                        <template v-else>
                                          <span class="close-row"> _ </span>
                                        </template>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                  <!-- if the invoice type other than part sale has been selected then the following table is displayed-->
                                  <table v-else class="table table-bordered table-sm" style="table-layout: fixed;">
                                        <thead>
                                            <tr class="table-primary">
                                                <!-- <th scope="col" class="require" style="width:350px">GL Account</th> -->
                                                <!-- <th scope="col" class="require">Description</th> -->
                                                <th scope="col" style="width:15%">Unit </th>
                                                <th scope="col" class="require" style="width:15%">Charge Code</th>
                                                <th scope="col" class="require" style="width:20%">GL Account</th>
                                                <th scope="col" class="require" style="width:10%">From Date</th>
                                                <th scope="col" class="require" style="width:10%">To Date</th>
                                                <th scope="col" class="require text-right" style="width:8% !important">Qty</th>
                                                <th scope="col" class="require text-right" style="width:8%">Unit Price</th>
                                                <!-- <th scope="col" class="text-right">Amount</th> -->
                                                <!-- <th scope="col" style="width:200px">Tax</th> -->
                                                <th scope="col" class="text-right" style="width:8%">Total</th>
                                                <th scope="col"> Action </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, index) in rows" :key="index">

                                                <td>
                                                    <v-select v-model="row.vehicle" :id="'vehicle_'+ index" :name="'vehicle_'+ index" label="text" :filterable="false" :options="vehicleArr" @search="onSearchAsset" placeholder="Select Unit" class='custom-ci-auto-search contract-data' :disabled="disableAll">
                                                        <template slot="no-options">
                                                            Search Unit No...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                    <div class="field-error">{{row.vehicle_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <!-- <v-select v-model="row.charge_code" id="charge_code" name="charge_code" label="text" :filterable="false" :options="chargeGlArr" @search="onSearchGLCharge" placeholder="Select Charge" class='custom-ci-auto-search contract-data' :disabled="disableAll">
                                                        <template slot="no-options">
                                                            Search Charge...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                    <div class="field-error">{{row.charge_code_error_msg}}</div>-->
                                                    <v-select v-model="row.charge_code" :id="'charge_code_'+ index" :name="'charge_code_'+ index" placeholder="Select Charge Code."
                                                                label="text"
                                                                :options="chargesArr" :disabled="disableAll" @input="onChangeGL()">
                                                    </v-select>
                                                    <div class="field-error">{{row.charge_code_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <v-select v-model="row.gl_account_id" :id="'gl_account_id_'+ index" :name="'gl_account_id_'+ index" label="text" :filterable="false" :options="accountsArr" @search="onSearchAccount" placeholder="GL Account" class='custom-ci-auto-search contract-data'>
                                                        <template slot="no-options">
                                                            Search GL Account...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                    <div class="field-error">{{row.gl_account_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <div class="form-group mb-0">
                                                        <div class="input-group">
                                                            <date-picker placeholder="MM/DD/YYYY" :id="'from_date_'+ index" :name="'from_date_'+ index" v-model="row.from_date" :config="optionsChargeDate" aria-describedby="basic-addon3" :disabled="disableAll"></date-picker>
                                                            <label for="from_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                                        </div>
                                                        <div class="field-error">{{row.from_date_error_msg}}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group mb-0">
                                                        <div class="input-group">
                                                            <date-picker placeholder="MM/DD/YYYY" :id="'to_date_'+ index" :name="'to_date_'+ index" v-model="row.to_date" :config="optionsChargeDate" aria-describedby="basic-addon3" :disabled="disableAll"></date-picker>
                                                            <label for="to_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                                        </div>
                                                        <div class="field-error">{{row.to_date_error_msg}}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <input type="text" placeholder="Quantity"
                                                      v-model="row.quantity"  :id="'quantity_'+ index" :name="'quantity_'+ index"  v-on:keyup="calculateAmount($event,index)" style="width:99% !important" class="vgt-input text-right"
                                                      @keypress="isNumberCheck($event,index, 'qty')" :disabled="disableAll">
                                                    <div class="field-error">{{row.quantity_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text" placeholder="Unit Price" v-model="row.unit_price" v-on:change="changeInput($event,index)"
                                                    @input="validateInput($event,index)" v-on:keyup="calculateAmount($event,index)"
                                                    @keypress="isNumberCheck($event,index, 'price')" :id="'unit_price_'+ index" :name="'unit_price_'+ index" style="width:99% !important" class="vgt-input text-right" :disabled="disableAll" >
                                                    <div class="field-error">{{row.unit_price_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text" disabled placeholder="Total"  v-model="row.total" id="total" name="total" style="width:99% !important" class="vgt-input text-right">
                                                </td>
                                                <td class="text-center valign-middle">
                                                    <template v-if="rows.length != 1">
                                                         <a href="javascript:void(0);" v-on:click="removeItem(index);"> <i class="fp-remove"></i> </a>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> _ </span>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="btn-groups mb-4">
                                    <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary" :disabled="disableAll">
                                        <i class="fp-add"></i> Add Line Item
                                    </button>
                                </div>
                                <template v-if="showTotalSummary">
                                    <div class="order-summary mt-4">
                                        <div class="row">
                                            <div class="col-md-6 offset-md-6">
                                                <div class="bg-white radius-5 p-3">
                                                    <label class="font-bold"> SUMMARY </label>
                                                    <table aria-describedby="table" class="table table-sm table-bordered">
                                                        <tr class="table-secondary">
                                                            <td>Subtotal:</td>
                                                            <td class="text-right">${{sub_total.toFixed(2)}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Tax Amount:</td>
                                                            <td class="text-right">${{total_tax.toFixed(2)}}</td>
                                                        </tr>
                                                        <tr class="table-secondary">
                                                            <td>Total:</td>
                                                            <td class="order-total text-right">${{total.toFixed(2)}}</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" :disabled='isDisableStore' id="CreateInvoiceBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateInvoice" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>

                                    <button type="submit" :disabled='isDisableStore' id="CreateInvoiceBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateInvoice" >
                                    <i class="fp-save"> </i>  Save
                                    </button>

                                    <button type="submit" :disabled='isDisableStore' id="createAndContinueInvoiceBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateInvoice(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>

                                    <button type="submit" id="cancelInvoiceBtn" class="btn btn-tertiary" v-on:click.prevent="BackInvoiceList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>

</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

import moment from 'moment';
export default {
    name: "InvoiceCreate",
    metaInfo() {
        return {
            title: (this.$route.params.id > 0)? "Update Customer Invoice | " +process.env.COPYRIGHT_NAME : "Create Customer Invoice | " +process.env.COPYRIGHT_NAME
        }
    },

    mixins:[commonMixins,contractMixins],
    data: () => ({
        isDisableStore: false,
        permissions: [],
        cantAccessPage: "",
        loading:false,
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: true,
        },
        optionsDueDate: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
        },
        customerArr:[],
        customer_id:null,
        customer_error_msg:"",
        invoice_number:"",
        // invoice_number_error_msg:"",
        invoice_date:null,
        invoice_date_error_msg:"",
        due_date:"",
        due_date_error_msg:"",
        customer_purchase_order:null,
        customerPurchaseOrderArr:[],
        invoice_type:null,
        invoice_type_error_msg:"",
        invoiceTypesArr:[],
        rows: [],
        sub_total:0,
        tax:0,
        total_tax:0,
        total:0,
        taxesArr:[],
        term:"",
        termsArr:[],
        location_id:"",
        locationArr:[],
        location_error_msg:"",
        reasonArr:[],
        reason_id : "",
        reason_error_msg : "",
        showTotalSummary:true,
        emails_error_msg:'',
        emails:'',
        disableAll:false,
        accountCanChanged:false,
        vehicleArr:[],
        chargesArr: [],
        optionsChargeDate: {
            format: 'MM/DD/YYYY',
            useCurrent: true,
        },
        disableInvType:true,
        allowInput:true,
        termPeriod:"",
        termTerm:"",
        customerCall:false,
        termCall:false,
        invDateCall:false,
        note:"",
        show_notes:false,
        chargeGlArr:[],
        gl_account_error_msg:"",
        isCredit:false,
        partSaleInvoiceItem:false,
        componentArr:[],
        isEdit: false,
        priceBookRateType: "",
        priceBookRate:0,
        priceBookMessage:"",
        base_price:0,
        partError: false,
        partErrorIndex:null,
        requestInProgress:false,
    }),
    watch:{
        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_invoice') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },
        sub_total:function(){
            var self = this;
            self.total= self.sub_total + self.total_tax;

        },
        total_tax:function(){
            var self = this;
            self.total= self.sub_total + self.total_tax;
        },
        //to populate due date and term
        // customer_id: function (newVal,oldVal) {
        //     console.log(newVal)
        //     var self = this;
        //     //prevent watch call for first time in case of update
        //     if (self.$route.params.id > 0 && !self.customerCall) {
        //         return;
        //     }else{

        //         if (self.$route.query.from != undefined && self.$route.query.from == 'credit'){

        //         }else{
        //             self.emails = newVal.email;
        //         }
        //         if (self.customer_id != null && newVal.term != "" ) {

        //             var date = '';
        //             if(newVal.term_period == 'month') {
        //                 date = moment(self.invoice_date, "MM/DD/YYYY")
        //                         .add(newVal.term_term,'month') //replace 2 with number of days you want to add

        //             }else{

        //                 date = moment(self.invoice_date, "MM/DD/YYYY")
        //                         .add(newVal.term_term,'days')
        //             }

        //             self.due_date = date;

        //         }
        //         if ( self.customer_id != null && newVal.location != "" ) {
        //             self.location_id = newVal.location;
        //         }
        //     }
        // },
        location_id:function(val){

            var self = this;
             if (self.$route.params.id != undefined && self.accountCanChanged == false){
                return;
            }
            if (val != null && val.value != undefined){
                if (self.rows.length > 1){
                    for(var i=0;i < self.rows.length; i++){
                        self.rows[i].account = '';
                    }
                }
            }
        },
        invoiceTypesArr:function(val){
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (!segments[3]) {
                var invoiceTypes = val;
                for(var i = 0; i < invoiceTypes.length;i++) {
                    if (invoiceTypes[i] != undefined && invoiceTypes[i] != null) {
                        if (invoiceTypes[i].text.includes("MC")) {
                            self.invoice_type = {
                                value:invoiceTypes[i].value,
                                text:invoiceTypes[i].text,
                            }
                        }
                      // if the invoiceType arr has the type of PS (part sales) then it is added to the invoice_type variable.
                      if (invoiceTypes[i].text.includes("PS")) {
                        self.invoice_type = {
                          value:invoiceTypes[i].value,
                          text:invoiceTypes[i].text,
                        }
                      }

                    }
                }
            }
        }
    },
    created: function() {

    },
    mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFieldData(['manualInvoiceTypes','taxes','terms','location','manual_invoice_charges','reason']);
        //self.loadFieldData(['manualInvoiceTypes','taxes','terms','location']);

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
            // set LoggedIn user's location as default location....
            if (userObj["location_id"] != null && userObj["location_id"] != '') {
                self.location_id = {
                    value: userObj["location_id"],
                    text: self.titleCase(userObj["locationName"]) + " | " + userObj["locationCode"]
                };
            }
        }

        var path = window.location.pathname;
        var segments = path.split("/");
        if (self.$route.query.inv_id != undefined && self.$route.query.inv_id > 0){
            self.loadInvoice(self.$route.query.inv_id);
        }
        if (segments[3]) {
            self.isEdit = true; // if the component has been called for the edit, then the isEdit is set to true.
            self.loadInvoice('');
        }else{
            self.rows.push({
                invoice_item_id:0,
                description:"",
                desc_error_msg:"",
                quantity:"1",
                existing_quantity:0,
                quantity_error_msg:"",
                part_name_error_msg:"",
                unit_price:"",
                unit_priceEdit:true,
                quantityEdit:true,
                unit_price_error_msg:"",
                amount:0,
                amount_error_msg:"",
                tax_id:"",
                tax_amount:0,
                total:0,
                account:"",
                vehicle:"",
                part:"",
                vehicle_error_msg:"",
                charge_code:"",
                charge_code_error_msg:"",
                from_date:"",
                from_date_error_msg:"",
                to_date:"",
                to_date_error_msg:"",
                gl_account_id:null,
                gl_account_error_msg:""
            });

            var todayDate = self.getTodayDate();

            self.optionsDate.maxDate = moment(todayDate,"MM/DD/YYYY");
            // self.optionsDueDate.minDate = moment(todayDate,"MM/DD/YYYY");
            self.invoice_date = todayDate;
        }
        if (self.$route.query.from != undefined && self.$route.query.from == 'credit'){
            self.isCredit = true;
        }
    },
    methods: {
        onChangeCustomer: function (newVal) {
            console.log(newVal)
            var self = this;
            //prevent watch call for first time in case of update
            // if (self.$route.params.id > 0 && !self.customerCall) {
            //     return;
            // }else{
                self.emails = newVal.email;
                if (self.customer_id != null && newVal.term != "" ) {

                    var date = '';
                    if(newVal.term_period == 'month') {
                        date = moment(self.invoice_date, "MM/DD/YYYY")
                                .add(newVal.term_term,'month') //replace 2 with number of days you want to add

                    }else{

                        date = moment(self.invoice_date, "MM/DD/YYYY")
                                .add(newVal.term_term,'days')
                    }

                    self.due_date = date;

                }
                if ( self.customer_id != null && newVal.location != "" ) {
                    self.location_id = newVal.location;
                }
                this.priceBookData();
            // }
        },
        BackInvoiceList() {
            var self = this;
            self.$router.push("/invoice/list");
        },
        onSearchCustomer(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'customer', 'manual-email');
            }
        },
        onSearchPO(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'customer_purchase_order', '');
            }
        },
        onChangeGL(){
            var self = this;
            var index=self.rows.length-1;

            $.ajax({
                url: process.env.ROOT_API + "/invoice/gl_account_id",
                type: "POST",
                data: {'location_id': self.location_id.value ,'chargecode': self.rows[index].charge_code.value },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    if (data.status == "success") {
                        if ( data.content != null ) {
                            self.rows[index].gl_account_id = {
                                value: data.content.id,
                                text: self.titleCase(data.content.code) + " | " + data.content.description
                            };
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.generateStatusCodeMessage(jqXHR,true,'invoice-item-delete');
                },
            });
        },
        onSearchGLCharge(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                if (self.location_id != null && self.location_id.value){

                    self.searchField(loading, search, 'gl_with_charge', self.location_id.value);

                }else{

                    self.searchField(loading, search, 'gl_with_charge', '');

                }
            }
        },
        onSearchAccount(search, loading) {
            var self = this;
            if (search.length > 5) {

                loading(true);
                self.searchField(loading, search, 'accounts', '');
            }
        },
        addRow: function () {
            var self = this;
            var index=self.rows.length-1;

            self.rows[index].desc_error_msg = "";
            self.rows[index].quantity_error_msg = "";
            self.rows[index].part_name_error_msg = "",
            self.rows[index].unit_price_error_msg = "";
            self.rows[index].unit_priceEdit = true;
            self.rows[index].quantityEdit = true;
            self.rows[index].amount_error_msg = "";
            self.rows[index].vehicle_error_msg = "";
            self.rows[index].charge_code_error_msg = "";
            self.rows[index].from_date_error_msg = "";
            self.rows[index].to_date_error_msg = "";
            self.rows[index].gl_account_error_msg = "";

            // if ( ( self.rows[index].description != null && self.rows[index].description != "" ) && ( self.rows[index].quantity != null && String(self.rows[index].quantity) != "") &&
            //     ( self.rows[index].unit_price != null && String(self.rows[index].unit_price) != "") && ( self.rows[index].amount != null && self.rows[index].amount != "") && (self.rows[index].account != null && self.rows[index].account.value)) {

          // condition for the unit invoice line item ( invoice type not part sale)
          var conditionUnit = ( self.rows[index].quantity != null && String(self.rows[index].quantity) != "") &&
            ( self.rows[index].unit_price != null && String(self.rows[index].unit_price) != "")
            &&  (self.rows[index].charge_code != null && self.rows[index].charge_code.value)
            &&  (self.rows[index].gl_account_id != null && self.rows[index].gl_account_id.value)
            && (self.rows[index].from_date && self.rows[index].from_date != null && self.rows[index].from_date != "") && (self.rows[index].to_date && self.rows[index].to_date != null && self.rows[index].to_date != "")
            && (!self.partSaleInvoiceItem);

          // condition for the part invoice line item ( invoice type is part sale)
          var conditionPart = ( self.rows[index].quantity != null && String(self.rows[index].quantity) != "")
            && ( self.rows[index].unit_price != null && String(self.rows[index].unit_price) != "")
            && self.partSaleInvoiceItem;

            if ( conditionUnit || conditionPart) {
                if (Date.parse(self.rows[index].to_date) < Date.parse(self.rows[index].from_date)) {
                    self.rows[index].to_date_error_msg = "To Date cannot be earlier than From Date.";
                    return;
                }
                if (self.partError){
                  self.rows[index].part_name_error_msg = "Cannot select the same part more than once";
                }else{

                  if (self.invoice_type.text === 'Part Sales (PS)') {
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var entered_quantity = parseFloat(self.rows[index].quantity);
                    var existing_quantity = parseFloat(self.rows[index].existing_quantity);
                    var available_quantity = parseFloat(self.rows[index].part.quantity);
                    var partError = false;
                    if (entered_quantity <= 0){
                      partError = true;
                      self.rows[index].quantity_error_msg = "Quantity should be greater than 0";
                    }else{
                      if (segments[3] && existing_quantity !== 0 ){

                        if (entered_quantity > existing_quantity){
                          var difference = entered_quantity - existing_quantity;
                          if (difference > available_quantity){ //if the difference is greater than the available quantity then return an error!
                            partError = true;
                            self.rows[index].quantity_error_msg = "Difference between the input and existing quantities is greater than the available quantity"
                          }else{
                            self.rows[index].quantity_error_msg = "";
                          }
                        }else{
                          self.rows[index].quantity_error_msg = "";
                        }
                      }
                      else{
                        if (self.rows[index].quantity > self.rows[index].part.quantity) {
                          self.rows[index].quantity_error_msg = "Input quantity is greater than available quantity"
                          partError = true;
                        }
                      }
                      if (!partError){
                        self.rows.push({
                          invoice_item_id:0,
                          description:"",
                          desc_error_msg:"",
                          quantity:"1",
                          existing_quantity:0,
                          quantity_error_msg:"",
                          part_name_error_msg:"",
                          unit_price:"",
                          unit_price_error_msg:"",
                          unit_priceEdit:true,
                          quantityEdit:true,
                          amount:0,
                          amount_error_msg:"",
                          tax_id:"",
                          tax_amount:0,
                          total:0,
                          vehicle:"",
                          part:"",
                          vehicle_error_msg:"",
                          charge_code:"",
                          charge_code_error_msg:"",
                          gl_account_id:null,
                          gl_account_error_msg:"",
                          from_date:"",
                          from_date_error_msg:"",
                          to_date:"",
                          to_date_error_msg:""
                        });
                      }
                    }
                  }
                  else{
                    self.rows.push({
                      invoice_item_id:0,
                      description:"",
                      desc_error_msg:"",
                      quantity:"1",
                      existing_quantity:0,
                      quantity_error_msg:"",
                      part_name_error_msg:"",
                      unit_price:"",
                      unit_price_error_msg:"",
                      unit_priceEdit:true,
                      quantityEdit:true,
                      amount:0,
                      amount_error_msg:"",
                      tax_id:"",
                      tax_amount:0,
                      total:0,
                      vehicle:"",
                      part:"",
                      vehicle_error_msg:"",
                      charge_code:"",
                      charge_code_error_msg:"",
                      gl_account_id:null,
                      gl_account_error_msg:"",
                      from_date:"",
                      from_date_error_msg:"",
                      to_date:"",
                      to_date_error_msg:""
                    });
                  }
                }
            }else{

                // if ( self.rows[index].description == null || self.rows[index].description == "" ) {
                //     self.rows[index].desc_error_msg = "Description Required.";
                // }
                if ( self.rows[index].quantity == null || String(self.rows[index].quantity) == "" ) {
                    self.rows[index].quantity_error_msg = "Quantity Required.";
                }
                if (self.invoice_type.text === 'Part Sales (PS)') {
                  if (self.rows[index].quantity > self.rows[index].part.quantity) {
                    self.rows[index].quantity_error_msg = "Input quantity is greater than available quantity"
                  }
                }
                if ( self.rows[index].unit_price == null || String(self.rows[index].unit_price) == "") {
                    self.rows[index].unit_price_error_msg = "Unit Price Required.";
                }
                // if (self.rows[index].amount == null || self.rows[index].amount == "" ) {
                //     self.rows[index].amount_error_msg = "Amount Required.";
                // }
              if (!self.partSaleInvoiceItem){ // only checking the fields relevant to the unit line item if the part sale invoice type has been selected
                if ( self.rows[index].gl_account_id == null || !self.rows[index].gl_account_id.value ) {
                  self.rows[index].gl_account_error_msg = "GL Account Required.";
                }
                // if ( self.rows[index].vehicle == null || !self.rows[index].vehicle.value ) {
                //     self.rows[index].vehicle_error_msg = "Unit Required.";
                // }
                if ( self.rows[index].charge_code == null || !self.rows[index].charge_code.value ) {
                  self.rows[index].charge_code_error_msg = "Charge Code Required.";
                }
                if (!self.rows[index].from_date || self.rows[index].from_date == null || self.rows[index].from_date == "") {
                  self.rows[index].from_date_error_msg = "From Date Required.";
                }
                if (!self.rows[index].to_date || self.rows[index].to_date == null || self.rows[index].to_date == "") {
                  self.rows[index].to_date_error_msg = "To Date Required.";
                }
                if ( (self.rows[index].from_date && self.rows[index].from_date != null && self.rows[index].from_date != "")
                  && (self.rows[index].to_date && self.rows[index].to_date != null && self.rows[index].to_date != "")
                  && (Date.parse(self.rows[index].to_date) < Date.parse(self.rows[index].from_date))) {
                  self.rows[index].to_date_error_msg = "To Date cannot be earlier than From Date.";
                }

                if (self.partError){
                  self.rows[index].part_name_error_msg = "Cannot select the same part more than once";
                }
              }
            }
            // if ( self.rows.length > 1) {
            //     self.showTotalSummary = true;
            // }else{
            //     self.showTotalSummary = false;
            // }
        },
        changeInput($event,index){
          console.log("CHNAGE INPUT");
          var self = this;
          // self.rows[index].unit_priceEdit = true;
          // if()
          // const formatter = new Intl.NumberFormat('en-US', { currency: 'USD', minimumFractionDigits:2, maximumFractionDigits:8});
          // self.rows[index].unit_price =  formatter.format(self.rows[index].unit_price);


        },
        validateInput(evt, index) {
          var self = this;
          self.isDisableStore = false;
          if(self.rows[index].unit_price > 999999.99) {
            self.rows[index].unit_priceEdit = false;

            self.rows[index].unit_price_error_msg = "Amount value exceed";
            self.isDisableStore = true;
            // unit_priceEdit:true,
                // quantityEdit:true,
          } else {
            self.rows[index].unit_priceEdit = true;
            self.rows[index].unit_price_error_msg = "";
          }

        },
        isNumberCheck: function(evt,index, type) {

          var self = this;
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            console.log(charCode);
            if ((charCode > 31 && (charCode < 48 || charCode > 57 ) && charCode != 45) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
                evt.preventDefault();
            } else {
              if(type == 'qty') {
                if(self.rows[index].quantityEdit) {
                  return true;
                } else {
                  evt.preventDefault();
                }
              } else {
                if(self.rows[index].unit_priceEdit) {
                  return true;
                } else {
                  evt.preventDefault();
                }
              }

            }
        },
        calculateAmount(evt, index) {
            var self = this;
            if (self.invoice_type.text === 'Part Sales (PS)'){
              var path = window.location.pathname;
              var segments = path.split("/");
              var entered_quantity = parseFloat(self.rows[index].quantity);
              var existing_quantity = parseFloat(self.rows[index].existing_quantity);
              var available_quantity = parseFloat(self.rows[index].part.quantity);
              // firstly check if the entered quantity is greater than 0 or not.
              if (entered_quantity <= 0){
                self.rows[index].quantity_error_msg = "Quantity should be greater than 0";
              }else{
                //check if it is update page or not, and if the current row has the existing data!
                if (segments[3] && existing_quantity !== 0 ){
                  // adding the validation for the quantity in the update page.
                  /*
                  * the quantity in the component inventory => self.rows[index].part.component_quantity
                  * the quantity in the invoice item => self.rows[index].existing_quantity
                  * the quantity entered by the user. => self.rows[index].quantity
                  * */
                  // check if entered quantity is greater than existing quantity
                  if (entered_quantity > existing_quantity){
                    var difference = entered_quantity - existing_quantity;
                    if (difference > available_quantity){
                      //if the difference is greater than the available quantity then return an error!
                      self.rows[index].quantity_error_msg = "Difference between the input and existing quantities is greater than the available quantity"
                    }else{
                      self.rows[index].quantity_error_msg = "";
                    }
                  }else{
                    self.rows[index].quantity_error_msg = "";
                  }
                }
                else{ // this validation is for the create page.
                  if (self.rows[index].quantity > self.rows[index].part.quantity){
                    self.rows[index].quantity_error_msg = "Input quantity is greater than available quantity"
                  }else{
                    self.rows[index].quantity_error_msg = "";
                  }
                }
              }
            }
            self.calculateTaxSubTotal();
        },
        calculateTaxSubTotal(){


            var self = this;
            var amount = 0;
            var taxAmount = 0

            for(var i=0;i<self.rows.length;i++) {

              if (self.rows[i].quantity != 0 || self.rows[i].unit_price != 0) {
                if (self.priceBookRateType === "M" && self.priceBookRate > 0) {
                  // this is markup
                  //Markup : finalAmount = ((markupValue/100) * rate) + rate
                  var unit_price = parseFloat(self.rows[i].unit_price);
                  var quantity = parseFloat(self.rows[i].quantity);
                  if (typeof (unit_price) == "number" && typeof (quantity) == "number") {
                    self.rows[i].amount = quantity * (unit_price + ((self.priceBookRate / 100) * unit_price));
                    self.rows[i].amount = parseFloat(self.rows[i].amount);
                    if (isNaN(self.rows[i].amount)) {
                      self.rows[i].amount = 0;
                    }
                  }
                } else if (self.priceBookRateType === "A" && self.priceBookRate > 0) {
                  // this is percentage
                  // x% of rate + rate ) * quantity = total
                  var unit_price = parseFloat(self.rows[i].unit_price);
                  var quantity = parseFloat(self.rows[i].quantity);
                  self.rows[i].amount = quantity * (unit_price + ((self.priceBookRate / 100) * unit_price));
                  if (isNaN(self.rows[i].amount)) {
                    self.rows[i].amount = 0;
                  }
                } else if (self.priceBookRateType === "G" && self.priceBookRate > 0) {
                  // this is margin
                  //margin :  rate + rate / (1 - (marginValue/100));
                  var unit_price = parseFloat(self.rows[i].unit_price);
                  var quantity = parseFloat(self.rows[i].quantity);
                  self.rows[i].amount = quantity * (unit_price + unit_price / (1 - (self.priceBookRate / 100)));
                  if (isNaN(self.rows[i].amount)) {
                    self.rows[i].amount = 0;
                  }
                } else {
                  if (self.rows[i].quantity.includes(',')) {
                    self.rows[i].quantity = self.rows[i].quantity.replace(',', '');
                    console.log("tax total", self.rows[i].quantity);
                      }
                      if(self.rows[i].unit_price.includes(',')){
                    self.rows[i].unit_price = self.rows[i].unit_price.replace(',', '');
                      }
                      // if(self.rows[i].unit_price > 999999.99) {
                      //   self.isDisableStore = true;
                      // } else {
                      //   self.isDisableStore = false;
                      // }
                      self.rows[i].amount=self.rows[i].quantity * self.rows[i].unit_price;
                      self.rows[i].amount = parseFloat(self.rows[i].amount);
                    }
                  console.log("AMOUT ==", self.rows[i].amount);
                  if (self.rows[i].amount > 999999.99) {
                    self.rows[i].unit_priceEdit = false;
                    self.rows[i].quantityEdit = false;
                    //
                    self.rows[i].unit_price_error_msg = "Amount value exceed";
                  } else {
                    // self.isDisableStore = false;
                    self.rows[i].unit_priceEdit = true;
                    self.rows[i].quantityEdit = true;
                    self.rows[i].unit_price_error_msg = "";
                  }

                  // self.rows[i].amount = self.rows[i].amount.toFixed(2);
                  if (self.rows[i].tax_id != null && self.rows[i].tax_id != "") {
                    self.rows[i].tax_amount = parseFloat((self.rows[i].amount * self.rows[i].tax_id.percentage) / 100);
                  } else {
                    self.rows[i].tax_amount = 0;
                  }
                  self.rows[i].total = self.rows[i].amount;
                  self.rows[i].total = parseFloat(self.rows[i].amount) + parseFloat(self.rows[i].tax_amount);
                  if (typeof (self.rows[i].total) == "NaN") {
                    self.rows[i].total = 0;
                  }
                  amount += parseFloat(self.rows[i].amount);
                  taxAmount += parseFloat(self.rows[i].tax_amount);
                }

              else
                {
                  if (self.rows[i].amount != "") {
                    // self.rows[i].amount = parseFloat(self.rows[i].amount);
                    self.rows[i].total = self.rows[i].amount;
                    if (self.rows[i].tax_id != null && self.rows[i].tax_id != "") {
                      self.rows[i].tax_amount = parseFloat((self.rows[i].amount * self.rows[i].tax_id.percentage) / 100);
                    } else {
                      self.rows[i].tax_amount = 0;
                    }
                    self.rows[i].total = parseFloat(self.rows[i].amount) + parseFloat(self.rows[i].tax_amount);
                    amount += parseFloat(self.rows[i].amount);
                    taxAmount += parseFloat(self.rows[i].tax_amount);
                  }
                }
              }


            // self.sub_total=0;
            // self.sub_total = self.rows.reduce(function(prev, cur) {
            //     // return prev + (cur.quantity * cur.unit_price);
            //     return prev + (cur.amount);
            // }, 0);
            self.sub_total = parseFloat(amount);

            // self.total_tax=0;
            // self.total_tax = self.rows.reduce(function(prev, cur) {
            //     return prev + (cur.tax_amount);
            // }, 0);
            self.total_tax= parseFloat(taxAmount);

            // self.total_tax = parseFloat((self.tax / 100) * self.sub_total);

        },
        removeItem: function (index) {
            var self = this;
            if(self.rows.length > 1) {
                if (self.rows[index].invoice_item_id == 0) {
                  if (index === self.partErrorIndex){
                    self.partErrorIndex = null;
                    self.partError = false;
                  }
                    self.rows.splice(index, 1);
                    self.calculateTaxSubTotal();

                }else {

                    if (confirm('Are you sure that you want to remove this line? ')) {

                        self.loading = true;
                        $.ajax({
                            url: process.env.ROOT_API + "/invoice/item/delete",
                            type: "POST",
                            data: {'invoice_item_id': self.rows[index].invoice_item_id},
                            headers: this.ajxHeaders,
                            dataType: "json",
                            success: function (data) {
                                if (data.status == "success") {

                                    setTimeout(function () {
                                        self.loadInvoice('');
                                        // self.loadInvoiceItems();
                                    },50);

                                }
                            },
                            error: function (jqXHR, exception) {
                                self.generateStatusCodeMessage(jqXHR,true,'invoice-item-delete');
                            },
                        });
                    }

                }
            }
            // if ( self.rows.length > 1) {
            //     self.showTotalSummary = true;
            // }else{
            //     self.showTotalSummary = false;
            // }
        },
        CreateInvoice(flag) {

            var self = this;
            var error = false;
            self.customer_error_msg = "";
            // self.invoice_number_error_msg = "";
            self.invoice_date_error_msg = "";
            self.due_date_error_msg = "";
            self.invoice_type_error_msg = "";
            self.location_error_msg = "";
            self.emails_error_msg = '';

            if ( self.customer_id == null ) {
                self.customer_error_msg = "Customer Required.";
                error = true;
            }

            /*if ( self.invoice_number == null || self.invoice_number == "" ) {
                self.invoice_number_error_msg = "Invoice No. Required.";
                error = true;
            }*/

            if (!self.invoice_date || self.invoice_date == null || self.invoice_date == "") {
                self.invoice_date_error_msg = "Invoice Date Required.";
                error = true;
            }

            if (!self.emails || self.emails == null || self.emails == "") {
                self.emails_error_msg = "Customer Email Required.";
                error = true;
            }

            if (self.emails.includes(',')){
                var emails = self.emails.split(',');

                if (emails.length > 0){
                    for( var i=0;i < emails.length;i++){
                        if (!self.validEmail(emails[i])){
                            self.emails_error_msg = 'Please enter valid email';
                            error = true;
                        }
                    }
                }
            }else{
                if (self.emails != '' && !self.validEmail(self.emails)){
                    self.emails_error_msg = 'Please enter valid email';
                    error = true;
                }
            }

            if (!self.due_date || self.due_date == null || self.due_date == "") {
                self.due_date_error_msg = "Due Date Required.";
                error = true;
            }

            if ( self.invoice_type == null ) {
                self.invoice_type_error_msg = "Invoice Type Required.";
                error = true;
            }

            if ( self.location_id == null || self.location_id == "" ) {
                self.location_error_msg = "Location Required.";
                error = true;
            }

            // if ( self.reason_id == null || self.reason_id == "" ) {
            //     self.reason_error_msg = "Reason Required.";
            //     error = true;
            // }

            if ( (self.invoice_date && self.invoice_date != null && self.invoice_date != "")
                && (self.due_date && self.due_date != null && self.due_date!= "")
                && (Date.parse(self.due_date) < Date.parse(self.invoice_date))) {
                self.due_date_error_msg = "Due Date cannot be earlier than Invoice Date.";
                error = true;
            }

            if (self.partError && self.partErrorIndex !== null){
              error = true;
              self.rows[self.partErrorIndex].part_name_error_msg = "Cannot select the same part more than once";
            }

            for (var i = 0; i < self.rows.length; i++) {

                // self.rows[i].desc_error_msg = "";
                self.rows[i].quantity_error_msg = "";
                self.rows[i].unit_price_error_msg = "";
                self.rows[i].amount_error_msg = "";
                self.rows[i].gl_account_error_msg = "";
                // self.rows[i].vehicle_error_msg = "";
                self.rows[i].charge_code_error_msg = "";
                self.rows[i].from_date_error_msg = "";
                self.rows[i].to_date_error_msg = "";

                // if ( self.rows[i].description == null || self.rows[i].description == "" ) {
                //     self.rows[i].desc_error_msg = "Description Required.";
                //     error = true;
                // }

                if (self.rows[i].quantity == null || String(self.rows[i].quantity) == "") {
                    self.rows[i].quantity_error_msg = "Quantity Required.";
                    error = true;
                }

                if (self.invoice_type.text === 'Part Sales (PS)') {
                  var path = window.location.pathname;
                  var segments = path.split("/");
                  var entered_quantity = parseFloat(self.rows[i].quantity);
                  var existing_quantity = parseFloat(self.rows[i].existing_quantity);
                  var available_quantity = parseFloat(self.rows[i].part.quantity);

                  if (entered_quantity <= 0){
                    error = true;
                    self.rows[i].quantity_error_msg = "Quantity should be greater than 0";
                  }else{
                    if (segments[3] && existing_quantity !== 0 ){

                      if (entered_quantity > existing_quantity){
                        var difference = entered_quantity - existing_quantity;
                        if (difference > available_quantity){
                          //if the difference is greater than the available quantity then return an error!
                          error = true;
                          self.rows[i].quantity_error_msg = "Difference between the input and existing quantities is greater than the available quantity"
                        }else{
                          self.rows[i].quantity_error_msg = "";
                        }
                      }else{
                        self.rows[i].quantity_error_msg = "";
                      }
                    }
                    else{ // this validation is for the create invoice.
                      if (self.rows[i].quantity > self.rows[i].part.quantity) {
                        self.rows[i].quantity_error_msg = "Input quantity is greater than available quantity"
                        error = true;
                      }
                    }
                  }
                }

                if (self.rows[i].unit_price == null || String(self.rows[i].unit_price) == "" ) {
                    self.rows[i].unit_price_error_msg = "Unit Price Required.";
                    error = true;
                }

                // if (self.rows[i].amount == null || self.rows[i].amount == "" ) {
                //     self.rows[i].amount_error_msg = "Amount Required.";
                //     error = true;
                // }

              if (!self.partSaleInvoiceItem){ // only checking the fields relevant to the unit line item if the part sale invoice type has been selected
                if ( self.rows[i].gl_account_id == null || self.rows[i].gl_account_id == "" ) {
                  self.rows[i].gl_account_error_msg = "GL Account Required.";
                  error = true;
                }
                // if ( self.rows[i].vehicle == null || self.rows[i].vehicle == "" ) {
                //     self.rows[i].vehicle_error_msg = "Unit Required.";
                //     error = true;
                // }
                if ( self.rows[i].charge_code == null || self.rows[i].charge_code == "" ) {
                  self.rows[i].charge_code_error_msg = "Charge Code Required.";
                  error = true;
                }
                if (!self.rows[i].from_date || self.rows[i].from_date == null || self.rows[i].from_date == "") {
                  self.rows[i].from_date_error_msg = "From Date Required.";
                  error = true;
                }
                if (!self.rows[i].to_date || self.rows[i].to_date == null || self.rows[i].to_date == "") {
                  self.rows[i].to_date_error_msg = "To Date Required.";
                  error = true;
                }
                if ( (self.rows[i].from_date && self.rows[i].from_date != null && self.rows[i].from_date != "")
                  && (self.rows[i].to_date && self.rows[i].to_date != null && self.rows[i].to_date != "")
                  && (Date.parse(self.rows[i].to_date) < Date.parse(self.rows[i].from_date))) {
                  self.rows[i].to_date_error_msg = "To Date cannot be earlier than From Date.";
                }
              }
            }

            if (!error) {
                self.loading = true;
                //check whether ar-subsytem is closed or not
                $.ajax({
                    url: process.env.ROOT_API + "/sub-system/check",
                    type: "POST",
                    data: {
                        flag:"ar-subsystem",
                        period:self.invoice_date
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        if (data.status == "success") {
                            self.invoiceCreate(flag);
                        } else {
                            self.loading = false;
                            if (data.content == 'closed') {
                                self.subsystemPromptMsg(flag,data.message);
                            }else{
                                self.$swal('',data.content,'info');
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'subsystem-inv-create');
                    }
                });
            }else{
                self.errorValidationFocus();
            }
        },
        invoiceCreate(flag) {
            var self = this;
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if ( self.requestInProgress == true ) {
                return;
            }
            self.requestInProgress = true;
            if (segments[3])
            {
                $("#CreateInvoiceBtn").val("Updating ...");
                $("#CreateInvoiceBtn").prop("disabled", true);
                $("#cancelInvoiceBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueInvoiceBtn").val("Saving ...");
                    $("#CreateInvoiceBtn").prop("disabled", true);
                    $("#createAndContinueInvoiceBtn").prop("disabled", true);
                    $("#cancelInvoiceBtn").prop("disabled",true);

                } else{

                    $("#CreateInvoiceBtn").val("Saving ...");
                    $("#CreateInvoiceBtn").prop("disabled", true);
                    $("#createAndContinueInvoiceBtn").prop("disabled", true);
                    $("#cancelInvoiceBtn").prop("disabled",true);
                }
            }

            var fields = $("#InvoiceForm").serializeArray();
            console.log(fields);

            fields.push({name: "customer_id", value: self.customer_id.value});

            if (self.invoice_type == null) {
                fields.push({name: "invoice_type", value: ""});
            } else{
                fields.push({name: "invoice_type", value: self.invoice_type.value});
            }

            if (self.customer_purchase_order == null) {
                fields.push({name: "customer_purchase_order_id", value: ""});
            } else{
                fields.push({name: "customer_purchase_order_id", value: self.customer_purchase_order.value});
            }

            if (self.term == null || self.term == "") {
                fields.push({name: "term", value: ""});
            } else{
                fields.push({name: "term", value: self.term.value});
            }

            if (self.location_id == null || self.location_id == "") {
                fields.push({name: "location_id", value: ""});
            } else{
                fields.push({name: "location_id", value: self.location_id.value});
            }

            fields.push({name: "sub_total", value: self.sub_total});
            /*if ( self.tax == "" || self.tax == null) {
                self.tax = 0;
                self.total_tax = 0;
                fields.push({name: "tax_percent", value: self.tax});
            }else{
                fields.push({name: "tax_percent", value: self.tax});
            }*/
            fields.push({name: "tax_amount", value: self.total_tax});
            fields.push({name: "total", value: self.total});

            if (!self.rows[0]) {

                self.rows = [];
            }

            for (var i = 0; i < self.rows.length; i++) {

                if (self.rows[i].tax_id == null || self.rows[i].tax_id == "") {
                    self.rows[i].tax_id = "";
                    self.rows[i].tax_amount = 0;
                    self.rows[i].total = self.rows[i].amount + self.rows[i].tax_amount;
                }
            }

            if (self.disableAll) {
                fields.push({name: "invoice_date", value: self.invoice_date});
                fields.push({name: "due_date", value: self.due_date});
            }

            fields.push({name: "invoiceItems", value: JSON.stringify(self.rows)});
            fields.push({ name: "id", value: segments[3] });
            if ( self.show_notes == true ) {
                fields.push({name: "show_notes", value: 1});
            }else{
                fields.push({name: "show_notes", value: 0});
            }

            fields.push({name:"priceBookRate",value:self.priceBookRate});

            fields.push({name:"reason_id",value: self.reason_id.value});

            fields.push({name:"parent_id",value:  self.$route.query.inv_id});

            console.log(fields);
            $.ajax({
                url: process.env.ROOT_API + "/invoice/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.requestInProgress = false;
                    self.loading = false;
                    // return;
                    if (segments[3])
                    {
                        $("#CreateInvoiceBtn").val("Update");
                        $("#CreateInvoiceBtn").prop("disabled", false);
                        $("#cancelInvoiceBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueInvoiceBtn").val("Save and Continue");
                            $("#CreateInvoiceBtn").prop("disabled", false);
                            $("#createAndContinueInvoiceBtn").prop("disabled", false);
                            $("#cancelInvoiceBtn").prop("disabled",false);

                        } else{

                            $("#CreateInvoiceBtn").val("Save");
                            $("#CreateInvoiceBtn").prop("disabled", false);
                            $("#createAndContinueInvoiceBtn").prop("disabled", false);
                            $("#cancelInvoiceBtn").prop("disabled",false);

                        }
                    }

                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#InvoiceForm").trigger("reset");
                            self.customer_id = null;
                            self.customer_purchase_order = null;
                            // self.invoice_number = "";
                            self.invoice_date = "";
                            self.due_date = "";
                            self.term = "";
                            self.emails = '';
                            self.note = "";
                            self.show_notes = 0;
                            // self.invoice_type = null;
                            self.rows=[];
                            self.rows.push({
                                invoice_item_id:0,
                                description:"",
                                desc_error_msg:"",
                                quantity:"1",
                                existing_quantity:0,
                                quantity_error_msg:"",
                                part_name_error_msg:"",
                                unit_price:"",
                                unit_price_error_msg:"",
                                unit_priceEdit:true,
                                quantityEdit:true,
                                amount:0,
                                amount_error_msg:"",
                                tax_id:"",
                                tax_amount:0,
                                total:0,
                                vehicle:"",
                                part:"",
                                vehicle_error_msg:"",
                                charge_code:"",
                                charge_code_error_msg:"",
                                gl_account_id:null,
                                gl_account_error_msg:"",
                                from_date:"",
                                from_date_error_msg:"",
                                to_date:"",
                                to_date_error_msg:""
                            });


                            self.sub_total = 0;
                            self.sub_total.toFixed(2);

                            // self.tax = 0;
                            self.total_tax = 0;
                            self.total_tax.toFixed(2);

                            self.total = 0;
                            // self.showTotalSummary = false;

                        } else{
                            self.$router.push("/invoice/list");
                        }

                    } else {

                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateInvoiceBtn").val("Update");
                        $("#CreateInvoiceBtn").prop("disabled", false);
                        $("#cancelInvoiceBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#PurchaseOrderForm").trigger("reset");
                            $("#createAndContinueInvoiceBtn").val("Save and Continue");
                            $("#CreateInvoiceBtn").prop("disabled", false);
                            $("#createAndContinueInvoiceBtn").prop("disabled", false);
                            $("#cancelInvoiceBtn").prop("disabled",false);

                        } else{

                            $("#CreateInvoiceBtn").val("Save");
                            $("#CreateInvoiceBtn").prop("disabled", false);
                            $("#createAndContinueInvoiceBtn").prop("disabled", false);
                            $("#cancelInvoiceBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,false,'invoice-create');
                }
            });
        },
        subsystemPromptMsg(flag,msg){
            var self = this;
            var promptMsg = msg;
            promptMsg += " Are you sure you want to proceed ?";
            self.$swal({
                title: promptMsg,
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: false
            }).then((result) => {
                if (result.value) {
                    self.invoiceCreate(flag);
                } else {

                }
            });
        },
        validEmail: function(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },

        onTaxSelect(event,index) {
            var self = this;
            if( self.rows[index].tax_id != null && self.rows[index].tax_id != ""){
                self.rows[index].tax_amount =  parseFloat(( self.rows[index].amount * self.rows[index].tax_id.percentage ) / 100);
                self.rows[index].total = self.rows[index].amount + self.rows[index].tax_amount;
            }else{
                self.rows[index].tax_amount = 0;
                self.rows[index].total = self.rows[index].amount + self.rows[index].tax_amount;
            }
            self.calculateTaxSubTotal();
        },
        loadInvoice(inv_id = '') {
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            var ids = '';
            if (inv_id != ''){
                ids = inv_id;
            }else{
                ids = segments[3];
            }
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/invoice/" + ids,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    if (data.status == "success") {
                        self.customer_id = {
                            value: data.content.customer_id,
                            text: self.titleCase(data.content.cusCode + " | " + data.content.cusName)
                        };
                        self.invoice_number = data.content.invoice_number;
                        // self.invoice_date = data.content.invoice_date;
                        // self.due_date = data.content.due_date;
                        if (self.isCredit == true){
                            self.invoice_date = self.getTodayDate();
                            if (data.content.termqty != undefined && data.content.term_period !=  undefined && data.content.term_period != null && data.content.term_period != ''){
                                // self.due_date = moment(self.invoice_date).add(data.content.termqty + ', "'+data.content.term_period.toLowerCase()+'"').format('MM/DD/YYYY');
                                self.due_date = moment(self.invoice_date, "MM/DD/YYYY").add(data.content.termqty, data.content.term_period.toLowerCase());
                            }
                        }else{
                            self.invoice_date = data.content.invoice_date;
                            self.due_date = data.content.due_date;
                        }
                        self.note = data.content.note;
                        if (data.content.show_notes == 1){
                            self.show_notes = true;
                        }else{
                            self.show_notes = false;
                        }
                        self.emails = data.content.customer_emails;
                        if (data.content.invoice_type_id != null) {
                            self.invoice_type = {
                                value:data.content.invoice_type_id,
                                text:self.formatString(data.content.invTypeName) + " (" + data.content.invTypeCode + ")"
                            }
                            if (data.content.invTypeCode == "PS"){
                              self.partSaleInvoiceItem = true;
                            }else{
                              self.partSaleInvoiceItem = false;
                            }
                            self.disableInvType = true;
                        }else{
                            self.invoice_type = null;
                        }

                        if (data.content.inv_status && data.content.inv_status == 'billed'){
                            if (self.$route.query.from != undefined && self.$route.query.from == 'credit'){
                                self.disableAll = false;
                            }else{
                                self.disableAll = true;
                            }
                            self.disableInvType = true;
                        }

                        if ( data.content.customer_po_id != null) {
                            self.customer_purchase_order = {
                                value:data.content.customer_po_id,
                                text:self.titleCase(data.content.cpoNumber)
                            }
                        }else{
                            self.customer_purchase_order = null;
                        }

                        if ( data.content.term_id != null) {
                            self.term = {
                                value:data.content.term_id,
                                text:self.titleCase(data.content.termName) + " (" + self.titleCase(data.content.termCode) + ")"
                            }
                        }else{
                            self.term = null;
                        }
                        if (data.content.location_id != null && data.content.location_id != "") {
                            self.location_id = {value:data.content.location_id,text:self.ucString(data.content.locName) + " | " + data.content.locCode};

                            setTimeout(function(){
                                self.accountCanChanged = true;
                            },2000);
                        }
                        setTimeout(function(){
                            self.customerCall = true;
                            self.termCall = true;
                            self.invDateCall = true;
                        },3000);

                        self.loadInvoiceItems(ids);

                        self.sub_total = self.reverseFormat(data.content.sub_total);
                        self.total_tax = self.reverseFormat(data.content.tax_amount);
                        self.total = self.reverseFormat(data.content.amount);
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'invoice-details');
                }
            });
        },
        loadInvoiceItems(ids) {
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/invoice/item/" + ids,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                        self.rows = [];
                        if (data.content.length >= 1) {
                            for (var i = 0; i < data.content.length; i++) {
                                self.rows.push({
                                    invoice_item_id:(self.$route.query.from != undefined && self.$route.query.from == 'credit') ? 0 : data.content[i].invoice_item_id,
                                    description:data.content[i].description,
                                    desc_error_msg:"",
                                    quantity:self.reverseFormat(self.amountFormat(data.content[i].quantity)),
                                    existing_quantity:self.reverseFormat(self.amountFormat(data.content[i].quantity)),
                                    quantity_error_msg:"",
                                    part_name_error_msg:"",
                                    unit_price:self.amountFormat(data.content[i].unit_price),
                                    unit_price_error_msg:"",
                                    amount:self.reverseFormat(self.amountFormat(data.content[i].amount)),
                                    amount_error_msg:"",
                                    tax_id:(data.content[i].tax_id != undefined && data.content[i].tax_id != null && data.content[i].tax_id != '') ? {
                                        value: data.content[i].tax_id,
                                        text: data.content[i].tax_name,
                                        percentage:data.content[i].tax_percentage,
                                    } : "",
                                    tax_amount:self.reverseFormat(self.amountFormat(data.content[i].tax_amount)),
                                    total:self.reverseFormat(self.amountFormat(data.content[i].total)),
                                    gl_account_id:(data.content[i].gl_account_id != undefined && data.content[i].gl_account_id != null && data.content[i].gl_account_id != '') ? {
                                        value: data.content[i].gl_account_id,
                                        text: data.content[i].gl_account_code + " | " + self.formatString(data.content[i].gl_account_desc),
                                    } : "",
                                    gl_account_error_msg:"",
                                    vehicle:(data.content[i].vehicle_id != undefined && data.content[i].vehicle_id != null && data.content[i].vehicle_id != '') ? {
                                        value: data.content[i].vehicle_id,
                                        text: data.content[i].vehicle,
                                    } : "",
                                    part:(data.content[i].component_inventory_id != undefined && data.content[i].component_inventory_id != null && data.content[i].component_inventory_id != '') ? {
                                      value: data.content[i].component_inventory_id,
                                      text: data.content[i].part,
                                      quantity: data.content[i].part_quantity,
                                      component_inventory_id: data.content[i].component_inventory_id
                                    } : "",
                                    vehicle_error_msg:"",
                                    charge_code:(data.content[i].charge_id != undefined && data.content[i].charge_id != null && data.content[i].charge_id != '') ? {
                                        value: data.content[i].charge_id,
                                        text: data.content[i].charge_code + ' | ' + data.content[i].charge_name,
                                        from:'edit'
                                    } : "",
                                    charge_code_error_msg:"",
                                    from_date:data.content[i].from_date,
                                    from_date_error_msg:"",
                                    to_date:data.content[i].to_date,
                                    to_date_error_msg:""
                                });
                            }

                        }else{
                            self.rows.push({
                                invoice_item_id:0,
                                description:"",
                                desc_error_msg:"",
                                quantity:"1",
                                existing_quantity:0,
                                quantity_error_msg:"",
                                part_name_error_msg:"",
                                unit_price:"",
                                unit_price_error_msg:"",
                                unit_priceEdit:true,
                                quantityEdit:true,
                                amount:0,
                                amount_error_msg:"",
                                tax_id:"",
                                tax_amount:0,
                                total:0,
                                vehicle:"",
                                part: "",
                                vehicle_error_msg:"",
                                charge_code:"",
                                charge_code_error_msg:"",
                                gl_account_id:null,
                                gl_account_error_msg:"",
                                from_date:"",
                                from_date_error_msg:"",
                                to_date:"",
                                to_date_error_msg:""
                            });
                        }
                        // if ( self.rows.length > 1) {
                        //     self.showTotalSummary = true;
                        // }else{
                        //     self.showTotalSummary = false;
                        // }
                    }

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'invoice-items');
                }
            });
        },
        titleCase(str) {
            if (str == null) {
                return;
            } else {
                var value = str.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },
        formatString(data) {
            var self = this;
            var value = data.replace(/_/g, " ");
            var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                return letter.toUpperCase();
            });
            return upp;
        },
        //on customer select prefill term value if term already defined for customer
        termSelect() {
            var self = this;
            if (self.customer_id != null) {
                if (self.customer_id.term_value != undefined) {
                    if (self.customer_id.term_value != null) {
                        self.term = {
                            text: self.customer_id.term,
                            value:self.customer_id.term_value,
                            term:self.customer_id.term_term,
                            period:self.customer_id.term_period,
                            code:self.customer_id.term_code
                        }
                    }
                }
                if (self.customer_id.email != undefined) {
                    if (self.customer_id.email != null && self.customer_id.email != "") {
                        self.emails = self.customer_id.email;
                    }else{
                        self.emails = "";
                    }
                }
            }
        },
        amountFormat(amount) {
            const formatter = new Intl.NumberFormat('en-US', {
                minimumFractionDigits:2,
                maximumFractionDigits:2
            });

            return formatter.format(amount);
        },
        onSearchAsset(search, loading) {
            var self = this;
            if (search.length > 3) {

                loading(true);
                self.searchField(loading, search, 'vehicle', '');
            }
        },
        onSearchComponent(search, loading) { // function to handle the searchable drop down of parts
          var self = this;
          if (search.length > 2) {

            loading(true);
            if(self.location_id != null && self.location_id.value){
              self.location_error_msg = "";
              self.searchField(loading, search, 'available component', self.location_id.value);
            }
            else{
              self.location_error_msg = "Location Required.";
            }
          }
        },
        onTermChange(e) {
            var self = this;
            if (self.term != null) {
                if (self.term.value != null) {
                    if (self.$route.params.id > 0 && !self.termCall) {
                        return;
                    }else{
                        self.calculateDueDate();
                    }
                }
            }
        },
        reverseFormat:function(amt){
            var self = this;

            if (self.$route.query.from != undefined && self.$route.query.from == 'credit'){
                if (amt > 0){
                    return -amt;
                }else{
                    return amt;
                }
            }else{
                return amt;
            }
        },
        onInvDateChange(e) {
            var self = this;
            //prevent watch call for first time in case of update
            if (self.$route.params.id > 0 && !self.invDateCall) {
                return;
            }else{
                self.calculateDueDate();
            }
        },
        calculateDueDate(){
            var self = this;
            if (self.invoice_date != null && self.invoice_date != "") {
                var isDueTerm = 0;
                if (self.term != null) {
                    if (self.term.value != null) {
                        if (self.term.code != undefined) {
                            if (self.term.code == "due") {
                                isDueTerm = 1;
                                self.due_date = self.invoice_date;
                            }
                        }
                        if (isDueTerm == 0) {
                            if (self.term.term != undefined) {
                                if (self.term.term != null) {
                                    if (self.term.period != null) {
                                        var date = '';
                                        if (self.term.period == "days") {
                                            date = moment(self.invoice_date, "MM/DD/YYYY").add(self.term.term,'days') //replace 2 with number of days you want to add
                                        }else if (self.term.period == "month") {
                                            date = moment(self.invoice_date, "MM/DD/YYYY").add(self.term.term,'month') //replace 2 with number of days you want to add
                                        }
                                        self.due_date = date;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        invoiceTypeChange: function (event){
          var self = this;
          if (event.text === "Part Sales (PS)"){
            self.partSaleInvoiceItem = true;
          }else{
            self.partSaleInvoiceItem = false;
          }
          var path = window.location.pathname;
          var segments = path.split("/");
          if (!segments[3]) {
            self.rows = []; // re-setting the data in the rows variable when the invoice type is changed.
            self.rows.push({
              invoice_item_id: 0,
              description: "",
              desc_error_msg: "",
              quantity: "1",
              existing_quantity:0,
              quantity_error_msg: "",
              part_name_error_msg:"",
              unit_price: "",
              unit_priceEdit: true,
              quantityEdit: true,
              unit_price_error_msg: "",
              amount: 0,
              amount_error_msg: "",
              tax_id: "",
              tax_amount: 0,
              total: 0,
              account: "",
              vehicle: "",
              part: "",
              vehicle_error_msg: "",
              charge_code: "",
              charge_code_error_msg: "",
              from_date: "",
              from_date_error_msg: "",
              to_date: "",
              to_date_error_msg: "",
              gl_account_id: null,
              gl_account_error_msg: ""
            });
          }
        },
        priceBookData: function (){
          var self = this;
          if (self.customer_id != null || self.location_id != null){
            self.loading = true;
            if (self.customer_id == null){
              var customerId = null;
              var classCode = null;
            }else{
              var customerId = self.customer_id.value;
              var classCode = self.customer_id.class;
            }

            if (self.location_id == null){
              var locationId = null;
            }else{
              var locationId = self.location_id.value;
            }
            $.ajax({
              url: process.env.ROOT_API + "/customer-location/pricebook",
              type: "POST",
              data: {
                customerId:customerId,
                locationId:locationId,
                classCode:classCode,
              },
              headers: {
                "Accept": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Authorization": "Bearer " + localStorage.getItem("tkn"),
                "Access-Control-Allow-Headers":
                  "Origin, Content-Type, Authorization,X-Requested-With",
                "Cache-Control": "no-cache"
              },
              dataType: "json",
              success: function (data) {

                if (data.status == "success") {
                  self.loading = false;
                  if (data.content.result != 0){
                    self.priceBookRate = data.content.result.rate;
                    self.priceBookRateType = data.content.result.rate_type;
                    self.priceBookMessage = data.content.message;
                  }else{
                    self.priceBookRate = 0;
                    self.priceBookRateType = "";
                    self.priceBookMessage = "";
                  }
                } else {
                  self.loading = false;
                  self.priceBookRate = 0;
                  self.priceBookRateType = "";
                  self.priceBookMessage = "";
                }
              },
              error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'subsystem-inv-create');
              }
            });
          }else{
            self.priceBookRate = 0;
            self.priceBookRateType = "";
          }
        },
      locationChange: function(event){
          var self = this;
          if (self.priceBookMessage !== "customer"){ // calling the api for price book only when the priceBookMessage is not customer
            this.priceBookData();
          }
      },
      partChange: function(event,row,index){
          var self = this;
        if (self.invoice_type.text === 'Part Sales (PS)') {
          var rowsLength = self.rows.length;
          var samePartCounter = 0;
          for (let i =0; i< rowsLength; i++){
            if (self.rows[i].part.component_inventory_id === row.part.component_inventory_id){
              samePartCounter ++;
            }
          }
          if (samePartCounter > 1){
            self.partError = true;
            self.partErrorIndex = index;
            row.part_name_error_msg = "Cannot select the same part more than once";
          }else{
            self.partError = false;
            row.part_name_error_msg = "";
            self.partErrorIndex = null;
          }
          if (row.part.base_price !== undefined){
            row.unit_price = row.part.base_price;
          }
        }
      }
    }

};
</script>
<style scoped>
.custom-padd{
    padding-left: 18px !important;
}
</style>
<style scoped>
/* for font size in sweet alert */
.swal2-title{
    font-size: 1em;
}
</style>




// WEBPACK FOOTER //
// src/components/invoice/InvoiceCreate.vue